import script from "./loginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./loginPage.vue?vue&type=script&setup=true&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=baeb424a&lang=scss"

const __exports__ = script;

export default __exports__